import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function DataProtectionPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    DTK COLLEGE Data Protection Policy
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Protecting Your Personal Information
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Director: Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V11 – 2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>30/04/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>30/04/2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>April 2027</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL Employees Freelance Staff, and Learners</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>Update: <strong>Children Act 2004</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Introduction */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. Introduction
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>1.1.</strong> DTK COLLEGE holds and processes information about employees, students, and other data subjects for academic, administrative, and commercial purposes. When handling such information, DTK COLLEGE, and all staff or others who process or use any personal information, must comply with the Data Protection Principles which are set out in the Data Protection Act 2018 (the Act), also including the General Data Protection Regulation (principles) 2018. In summary these state that personal data shall:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '25px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>be processed fairly and lawfully,</li>
                    <li style={{ marginBottom: '10px' }}>be obtained for a specified and lawful purpose and shall not be processed in any manner incompatible with the purpose,</li>
                    <li style={{ marginBottom: '10px' }}>be adequate, relevant and not excessive for the purpose</li>
                    <li style={{ marginBottom: '10px' }}>be accurate and up to date,</li>
                    <li style={{ marginBottom: '10px' }}>not be kept for longer than necessary for the purpose,</li>
                    <li style={{ marginBottom: '10px' }}>be processed in accordance with the data subject's rights,</li>
                    <li style={{ marginBottom: '10px' }}>be kept safe from unauthorised processing, and accidental loss, damage or destruction,</li>
                    <li>not be transferred to a country outside the European Economic Area, unless that country has equivalent levels of protection for personal data, except in specified circumstances.</li>
                  </ul>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    1.2. Definitions
                  </h4>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>"Data controller" further information about DTK COLLEGE's data controllers is available from the Data Protection Officer</li>
                    <li style={{ marginBottom: '10px' }}>"Staff", "students" and "other data subjects" may include past, present and potential members of those groups.</li>
                    <li style={{ marginBottom: '10px' }}>"Other data subjects" and "third parties" may include contractors, suppliers, contacts or referees.</li>
                    <li>"Processing" refers to any action involving personal information, including obtaining, viewing, copying, amending, adding, deleting, extracting, storing, disclosing or destroying information.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Notification of Data Held */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Notification of Data Held
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>2.1.</strong> DTK COLLEGE shall notify all staff and students and other relevant data subjects of the types of data held and processed concerning them, and the reasons for which it is processed. The information which is currently held by DTK COLLEGE and the purposes for which it is processed are set out in the Data Protection Register entry. When processing for a new or different purpose is introduced, the individuals affected by that change will be informed and the Data Protection Register entry will be amended.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Staff Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    3. Staff Responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>3.1.</strong> All staff shall
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '25px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>ensure that all personal information which they provide to DTK COLLEGE in connection with their employment is accurate and up to date.</li>
                    <li style={{ marginBottom: '10px' }}>inform DTK COLLEGE of any changes to information, for example, changes of address.</li>
                    <li>check the information which DTK COLLEGE shall make available from time to time, in written or automated form, and inform of any errors or, where appropriate, follow procedures for up-dating entries on computer forms. DTK COLLEGE shall not be held responsible for errors of which it has not been informed.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>3.2.</strong> When staff hold or process information about students, colleagues or other data subjects (for example, students' course work, pastoral files, references to other academic institutions, or details of personal circumstances), they should comply with the following.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>3.3.</strong> Staff shall ensure that:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '25px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>all personal information is kept securely.</li>
                    <li style={{ marginBottom: '10px' }}>Personal information is not disclosed either orally or in writing, accidentally or otherwise to any unauthorised third party. Unauthorised disclosure may be a disciplinary matter and may be considered gross misconduct in some cases. The transmission of confidential information, either hard-copy or electronically (to be sent to other staff, students, or a trusted third party) must be done so securely, including sending for a receipt acknowledgement (by the named recipients) per transmission instance.</li>
                    <li style={{ marginBottom: '10px' }}>Hard-copy information to be transmitted must also be franked (for special delivery) to include tracking.</li>
                    <li style={{ marginBottom: '10px' }}>Email to be transmitted should be encrypted beforehand.</li>
                    <li>Students are made aware of the importance of the Data Protection Act 2018 and GDPR and how this affects DTK COLLEGE's processing of information, notably, the impacts the GDPR is likely to have when processing information and where in processing such information any problems could arise in complying with the GDPR.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>3.4.</strong> When staff supervise students doing work which involves the processing of personal information, they must ensure that those students are aware of the Data Protection Principles: the requirement to obtain the data subject's consent where appropriate.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. Student Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    4. Student Responsibilities
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>4.1.</strong> All students shall:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '25px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>ensure that all personal information which they provide to DTK COLLEGE is accurate and up to date.</li>
                    <li style={{ marginBottom: '10px' }}>inform DTK COLLEGE of any changes to that information, for example, changes of address.</li>
                    <li style={{ marginBottom: '10px' }}>check the information which DTK COLLEGE shall make available from time to time, in written or automated form, and inform DTK COLLEGE of any errors or, where appropriate, follow procedures for up-dating entries on computer forms. DTK COLLEGE shall not be held responsible for errors of which it has not been informed.</li>
                    <li>Where the student is under 18 years consent must be given by a person holding parental responsibility.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>4.2.</strong> Students who use DTK COLLEGE computer facilities may, from time to time, process personal information (for example, in course work or research). In those circumstances, they must notify the Data Controller, who will provide further information about this requirement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 5. Rights to Access Information */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5. Rights to Access Information
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>5.1.</strong> Staff, students, and other data subjects in DTK COLLEGE have the right to access any personal data that is being kept about them either on a computer or in structured and accessible manual files. Any person may exercise this right by submitting a request in writing to the appropriate designated data controller.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>5.2.</strong> DTK COLLEGE will not make any charges for an official Subject Access Request under the Act.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>5.3.</strong> DTK COLLEGE aims to comply with requests for access to personal information as quickly as possible but will ensure that it is provided within 5 days unless there is good reason for delay. In such cases, the reason for the delay will be explained in writing by the designated data controller to the data subject making the request.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>5.4.</strong> All parties retain the right to receive personal information they have provided to the data controller in a commonly used, structured and machine-readable format, the right to data portability. This right applies when:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>An individual has provided personal information to a data controller.</li>
                    <li style={{ marginBottom: '10px' }}>The processing is based on the individual's consent or for the performance of a contract.</li>
                    <li>Processing is carried out by means of automation.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 6. Subject Consent */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    6. Subject Consent
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>6.1.</strong> In some cases, such as the handling of sensitive information or the processing of research data, DTK COLLEGE is entitled to process personal data only with the consent of the individual. Agreement to the processing of some specified classes of personal data is a condition of acceptance of a student on to any course, and a condition of employment for staff. (See Data Protection Register entry)
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>6.2.</strong> DTK COLLEGE may process sensitive information about a person's health, disabilities, criminal convictions, race or ethnic origin, or trade union membership in pursuit of the legitimate interests of DTK COLLEGE. For example, some jobs or courses will bring the applicants into contact with children, including young people between the ages of 16 and 18, and DTK COLLEGE has a duty under the Children Act 2004 and other enactments to ensure that staff are suitable for the job, and students for the courses offered. DTK COLLEGE may also require such information for the administration of the sick pay policy, the absence policy or the equality and diversity policy, or for academic assessment.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>6.3.</strong> DTK COLLEGE also asks for information about health needs, such as allergies to forms of medication, or conditions such as asthma or diabetes. DTK COLLEGE will only use such information to protect the health and safety of the individual, for example, in the event of a medical emergency. The consent of the data subject will always be sought prior to the collection of any sensitive data as defined by the Act.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7. The Data Controller and the Designated Data Controllers */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    7. The Data Controller and the Designated Data Controllers
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>7.1.</strong> The Board of Directors for DTK COLLEGE is the data controller under the Act and is ultimately responsible for implementation. Responsibility for day-to-day matters will be delegated to the Heads of Department as designated data controllers. Information and advice about the holding and processing of personal information is available from the Data Protection Officer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 8. Assessment Marks */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    8. Assessment Marks
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>8.1.</strong> Students shall be entitled to information about their marks for assessments, however this may take longer than other information to provide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 9. Retention of Data */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    9. Retention of Data
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>9.1.</strong> DTK COLLEGE will keep different types of information for differing lengths of time, depending on legal, academic, and operational requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 10. Data Breaches */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    10. Data Breaches
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>10.1</strong> Where a breach is likely to result in a high risk to the rights and freedoms of individuals DTK COLLEGE will notify those concerned directly and the ICO.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 11. Compliance */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    11. Compliance
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>11.1.</strong> Compliance with the Act is the responsibility of all students and members of staff. Any deliberate or reckless breach of this Policy may lead to disciplinary, and where appropriate, legal proceedings. Any questions or concerns about the interpretation or operation of this policy should be taken up with the Data Protection Officer.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    <strong>11.2.</strong> Where processing information is likely to result in high risk to individuals, for example in the following instances:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '25px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '8px' }}>where a new technology is in deployment.</li>
                    <li style={{ marginBottom: '8px' }}>where a profiling operation is likely to have a significant impact on individuals.</li>
                    <li>where there is large scale processing of the special categories of data.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    A 'Data Protection Impact Assessment' (DPIA) will be carried out to assess such risks. Should the assessment conclude that the data processing is high risk, and cannot be fully addressed, the Information Commissioner's Office (ICO) will be consulted to assess whether the processing operation(s) are compliant with GDPR guidelines.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>11.3.</strong> Any individual, who considers that the policy has not been followed in respect of personal data about him or herself, should raise the matter with the designated data controller initially. If the matter is not resolved it should be referred to the staff grievance or student complaints procedure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default DataProtectionPolicy;